import axios from 'axios'
import React, { useEffect, useState  } from 'react'
import { toast } from 'react-toastify'
import { formatToZMW, rootUrl, sumOfArray } from '../../../helpers'
import { useOutletContext } from 'react-router-dom';
import DataTable from "react-data-table-component";
import * as XLSX from "xlsx";
import { AiOutlineStock } from 'react-icons/ai';
import { FaPlus } from 'react-icons/fa';
import { useAuth } from '../../../context/auth-context';


export default function Products() {

    const {allData, setAllData} = useOutletContext();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [excelData, setExcelData] = useState([]);
    const [loading, setLoading] = useState(false);
    // const [stockvalue, setStockvalue] = useState(0.0);

    const auth = useAuth();

    const fetchData = async ()=>{
        try{
            const data = await axios.get(rootUrl(`/getProducts/${auth.user.shop}`))
            setAllData(data.data)
        }catch(e){
            toast.error(e?.message)
        }
    }

    useEffect(()=>{
      fetchData()
    },[])

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;
    
        const reader = new FileReader();
        reader.onload = (event) => {
          const data = new Uint8Array(event.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const sheet = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
          setExcelData(sheet);
        };
        reader.readAsArrayBuffer(file);
      };


      const handleSubmit = async () => {
        setLoading(true);
        try {
          const response = await axios.post(rootUrl(`/addProduct`), { products: excelData, shop:auth.user.shop });
          
          if(response.data.status == 200){
            toast.success("Products uploaded successfully!");
            setIsModalOpen(false);
            fetchData()
            setLoading(false);
          }else{
            toast.error("Error, please again later");
            setLoading(false);
          }

        } catch (error) {
          console.error("Upload Error:", error);
          toast.error(error?.message);
          setLoading(false);
        }
      };

      const stockvalue = sumOfArray(allData?.products?.map(res=>parseFloat(res.amount) * parseInt(res.stock)))
      const stockqty = sumOfArray(allData?.products?.map(res=>parseFloat(res.stock)))

    return (
      <div>

        <div className='flex justify-between p-2 items-center'>

        <h2 className='font-bold text-2xl flex items-center'> <AiOutlineStock/> Products</h2>

        <button
        className="bg-blue-950 text-white px-4 py-2 rounded mb-4 flex items-center"
        onClick={() => setIsModalOpen(true)}
      >
       <FaPlus/> Add Product
      </button>

        </div>

        
        <hr className='my-3'/>

        <span>Total Stock: {formatToZMW(stockvalue)}</span>
        <br />
        <span>Total Quantity: {stockqty}</span>

        <TableComponent data={allData.products} />


          {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
          <div className="bg-white p-5 rounded shadow-lg w-1/2">
            <h2 className="text-xl font-bold mb-4">Upload Products</h2>

            {/* File Input */}
            <input
              type="file"
              accept=".xlsx, .xls"
              className="mb-3 p-2 border w-full"
              onChange={handleFileUpload}
            />

               {/* Buttons */}
               <div className="flex justify-end my-4">
              <button
                className="bg-gray-500 text-white px-4 py-2 rounded mr-2"
                onClick={() => setIsModalOpen(false)}
              >
                Cancel
              </button>
              <button
                className="bg-green-500 text-white px-4 py-2 rounded"
                disabled={loading} 
                onClick={handleSubmit}
              >
                {loading ? "Uploading..." : "Submit"}
              </button>
            </div>

<div className='h-[50vh] p-5 overflow-auto'>

   {/* Preview Table */}
   {excelData.length > 0 && (
              <table className="w-full border-collapse border text-sm">
                <thead>
                  <tr className="bg-gray-200">
                    {Object.keys(excelData[0]).map((key) => (
                      <th key={key} className="border p-2">{key}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {excelData.map((row, index) => (
                    <tr key={index} className="border">
                      {Object.values(row).map((value, i) => (
                        <td key={i} className="border p-2">{value}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

</div>
           

         
          </div>
        </div>
      )}
      </div>
    )
}

const TableComponent = ({ data }) => {
    const columns = [
      { name: "Barcode", selector: (row) => row.barcode, sortable: true },
      { name: "Name", selector: (row) => row.name, sortable: true },
      { name: "Amount", selector: (row) => row.amount, sortable: true },
      { name: "Stock", selector: (row) => row.stock, sortable: true },
    ];
  
    const [filterText, setFilterText] = useState("");
  
    const filteredData = data.filter(
      (item) =>
        item.name.toLowerCase().includes(filterText.toLowerCase()) ||
        item.barcode.toLowerCase().includes(filterText.toLowerCase())
    );
  
    return (
      <div className="p-4">
        {/* Search Input */}
        <input
          type="text"
          placeholder="Search..."
          className="border p-2 mb-3 w-full"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
        />
     
        {/* DataTable */}
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          highlightOnHover
          responsive
        />
      </div>
    );
  };
  
